module.exports = __webpack_public_path__ + "img/notts-police-logo.d231caed.png";